import _ from 'lodash'
import React from 'react';
import {useSelector} from 'react-redux';
import {createSelector} from 'reselect'
import {AppVersionInfoButton} from 'module/TopNavBar/component/TopNavBarButton/AppVersionInfoButton';
import {TopNavBarButtonDomIDs, TopNavBarButtonID} from 'module/TopNavBar/enum/TopNavBarButtonEnums';
import {KostPanelButton} from 'module/TopNavBar/component/TopNavBarButton/KostPanelButton';
import {PersonPanelButton} from 'module/TopNavBar/component/TopNavBarButton/PersonPanelButton';
import {TopNavBarButtonGroup} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonGroup';
import {HamburgerPanelButton} from 'module/TopNavBar/component/TopNavBarButton/HamburgerPanelButton';
import {LabelISSPanelButton} from 'module/TopNavBar/component/TopNavBarButton/LabelISSPanelButton';
import {SettingsPanelButton} from 'module/TopNavBar/component/TopNavBarButton/SettingsPanelButton';

export const TopNavBarLeftButtonSection = React.memo(() => {
	const btnDefs = useSelector(createSelector(
		state => state.TopNavBar.buttons,
		(btn) => _.sortBy(_.values(btn).filter(x => x.visible), 'nr'),
	));

	return (
		<TopNavBarButtonGroup>
			{_.map(btnDefs, (btn) => {
				let Btn;
				switch (btn.name) {
					case TopNavBarButtonID.Hamburger:
						Btn = HamburgerPanelButton;
						break;
					case TopNavBarButtonID.Person:
						Btn = PersonPanelButton;
						break;
					case TopNavBarButtonID.Kost:
						Btn = KostPanelButton;
						break;
					case TopNavBarButtonID.Settings:
						Btn = SettingsPanelButton;
						break;
					case TopNavBarButtonID.LabelISS:
						Btn = LabelISSPanelButton;
						break;
					case TopNavBarButtonID.AppVersionInfo:
						Btn = AppVersionInfoButton;
						break;
					default:
						Btn = null;
						break;
				}
				return <Btn key={btn.name} btnDef={btn} id={TopNavBarButtonDomIDs[btn.name]}/>
			})}
		</TopNavBarButtonGroup>
	);
});